import React from 'react';
import {Link} from 'react-router-dom';
import styles from './ServiceCard.module.css';

const ServiceCardContent = ({service, showMore}) => (
    <>
        <div className={styles.imageWrap}>
            <img src={service.image} alt={service.title} width="240" height="180" loading="lazy"/>
        </div>
        <div className={styles.content}>
            <h3>{service.title}</h3>
            <p>{service.description}</p>
            <ul aria-label={`Примеры услуг: ${service.title}`}>
                {service.items.map((item) => <li key={item}>{item}</li>)}
            </ul>
            {showMore && <span className={styles.more}>Подробнее</span>}
        </div>
    </>
);

const ServiceCard = ({service, linkable = true, onClick}) => (
    <article className={`${styles.card} ${linkable || onClick ? styles.clickable : ''}`}>
        {linkable ? (
            <Link to={service.route} className={styles.link}>
                <ServiceCardContent service={service} showMore/>
            </Link>
        ) : onClick ? (
            <div
                role="button"
                tabIndex={0}
                className={styles.button}
                onClick={onClick}
                onKeyDown={(event) => {
                    if (event.key === 'Enter' || event.key === ' ') {
                        event.preventDefault();
                        onClick();
                    }
                }}
            >
                <ServiceCardContent service={service} showMore={false}/>
            </div>
        ) : (
            <div className={styles.staticContent}>
                <ServiceCardContent service={service} showMore={false}/>
            </div>
        )}
    </article>
);

export default ServiceCard;
